import styled from "styled-components";

export const StyledLink = styled.a`
    display: inline-flex;
    text-decoration: underline;
    cursor: pointer;
    color: ${globalThis.config.colors.black};
    :hover {
        color: ${globalThis.config.colors.black};
    }
    &:not([href]) {
        text-decoration: underline;
        color: ${globalThis.config.colors.black};
        :hover {
            text-decoration: underline;
            color: ${globalThis.config.colors.black};
        }
    }

    ${(props) =>
        props.disabled &&
        `
        cursor: default;
        color: ${globalThis.config.colors.gray4};
        :hover {
            color: ${globalThis.config.colors.gray4};
        }
        &:not([href]) {
            cursor: default;
            color: ${globalThis.config.colors.gray4};
            :hover {
                color: ${globalThis.config.colors.gray4};
            }
        }
    `}

    ${(props) =>
        props.noUnderline &&
        `
        text-decoration: none;
        :hover {
            text-decoration: none;
        }
        &:not([href]) {
            text-decoration: none;
            :hover {
                text-decoration: none;
            }
        }
    `}

    ${(props) =>
        props.noHover &&
        `
        :hover {
            color: ${globalThis.config.colors.black};
        }
        &:not([href]) {
            :hover {
                color: ${globalThis.config.colors.black};
            }
        }
    `}

    ${(props) =>
        props.color &&
        `
        color: ${props.color};
        &:not([href]) {
            color: ${props.color};
        }
    `}

    font-size: 0.75rem;
    font-family: HelveticaNeueW02-55Roma;
`;
